export const PAGE_EVENTS_COMPARE_DOMAINS = [
    'programeregionale.eu/lp2', 
    'dailyjournalhub.com/bg-language-program-quiz-ab', 
    'dailyjournalhub.com/lt-language-program-quiz-ab',
    'dailyjournalhub.com/lv-language-program-quiz-ab',
];
